/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyMultifactorAuthentication} from '../api'

export const useMutationVerifyMultifactorAuthentication = createReactQueryMutationHook('verifyMultifactorAuthentication', verifyMultifactorAuthentication)
